<template>
  <AdvancedDropdown
    v-model="selectedItems"
    v-bind="$attrs"
    v-on="$listeners"
    :options="optionItems"
    :loading="isFetching"
    :text="$props.placeholder"
    :multiple="$props.multiple"
    :can-add-new="false"
    @toggle="() => (selectedItems = $props.value)"
  >
    <!-- TODO: Remove if no add new feature. It stays here for now -->
    <template v-slot:add-new="{ cancel }">
      <CompanyRLSDropdownAddNewForm @cancel="cancel" />
    </template>

    <template v-slot:default="defaultSlotData">
      <slot v-bind="{ ...defaultSlotData, selectedItems }" />
    </template>

    <template v-slot:item-extra="itemExtraSlotData">
      <slot
        name="item-extra"
        v-bind="{ ...itemExtraSlotData, selectedItems }"
      />
    </template>

    <template v-slot:footer="{ hide }">
      <CompanyRLSDropdownFooter @cancel="hide" @saved="() => onSaved(hide)" />
    </template>
  </AdvancedDropdown>
</template>

<script>
import { defineComponent, computed, provide, ref } from '@vue/composition-api'

import { useRLSGroup } from '@composables'
import { AdvancedDropdown } from '@components/advanced'

import CompanyRLSDropdownAddNewForm from './CompanyRLSDropdownAddNewForm.vue'
import CompanyRLSDropdownFooter from './CompanyRLSDropdownFooter.vue'

export default defineComponent({
  name: 'CompanyRLSDropdown',
  components: {
    AdvancedDropdown,

    CompanyRLSDropdownAddNewForm,
    CompanyRLSDropdownFooter
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    rlsGroup: {
      type: String,
      required: true
    },
    multiple: Boolean,
    placeholder: String
  },
  emits: ['saved'],
  setup(props, { emit }) {
    const { isFetching, rlsGroupItems } = useRLSGroup(props.rlsGroup)

    const selectedItems = ref([])

    const optionItems = computed(() =>
      rlsGroupItems.value.map((item) => ({
        text: item[props.rlsGroup] || item[props.rlsGroup.toLowerCase()],
        value: item.id
      }))
    )

    const onSaved = (callback) => {
      emit('saved', props.rlsGroup)

      callback()
    }

    provide('company-rls-dropdown', {
      ...props,

      selectedItems
    })

    return {
      isFetching,

      selectedItems,
      optionItems,

      onSaved
    }
  }
})
</script>

<style scoped>
.b-dropdown >>> .form-group div[role='group'] {
  max-height: 100%;
}
</style>
